import { render } from "./IconGift.vue?vue&type=template&id=8657cdbe"
import script from "./IconGift.vue?vue&type=script&lang=js"
export * from "./IconGift.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__